import React from 'react';

export function KpiCard({ title, children }) {
  return (
    <div className="ci-kpi-card">
      <div className="ci-kpi-title">{title}</div>
      {children}
    </div>
  );
}
